module.exports = __webpack_public_path__ + "static/media/1.8a593ea8.mp4";